

export const soraHero = {
    title: 'Sora 2 AI 视频生成器',
    tags: '无水印 • 无邀请码 • 无需下载 App',
    desc:
      '体验 OpenAI 最新 Sora 2 模型。将文字或图片转为逼真视频，具备高级运动与物理一致性。适合创作与社媒内容。'
  };
